"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _commonCta = require("@mmc/common-cta");
var _dealerHours = _interopRequireDefault(require("./dealer-hours"));
var _dealerDetails = _interopRequireDefault(require("./dealer-details.css"));
var DealerDetails = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(DealerDetails, _React$Component);
  function DealerDetails(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var mobileBreakpoint = 768;
    _this.state = {
      isMobile: typeof window !== 'undefined' && window.innerWidth < mobileBreakpoint,
      isTimingsVisible: true
    };
    _this.toggleTimings = _this.toggleTimings.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = DealerDetails.prototype;
  _proto.toggleTimings = function toggleTimings() {
    this.setState(function (prevState) {
      return {
        isTimingsVisible: !prevState.isTimingsVisible
      };
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      dealerName = _this$props.dealerName,
      dealerAddress = _this$props.dealerAddress,
      dealerDepartments = _this$props.dealerDepartments,
      selectedLabel = _this$props.selectedLabel,
      editLabel = _this$props.editLabel,
      salesLabel = _this$props.salesLabel,
      servicesLabel = _this$props.servicesLabel,
      saleOpeningHoursLabel = _this$props.saleOpeningHoursLabel,
      serviceOpeningHoursLabel = _this$props.serviceOpeningHoursLabel,
      theme = _this$props.theme,
      departmentsCode = _this$props.departmentsCode,
      editHandler = _this$props.editHandler;
    var _this$state = this.state,
      isMobile = _this$state.isMobile,
      isTimingsVisible = _this$state.isTimingsVisible;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerDetails["default"].dealerDetails
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerDetails["default"].dealerDetailsContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerDetails["default"].backButtonSection
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: theme.critical + " " + theme.smallType + " " + _dealerDetails["default"].selectedButton
    }, selectedLabel), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: _dealerDetails["default"].dealerBackLink,
      onClick: editHandler
    }, editLabel)), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.headingFour + " " + _dealerDetails["default"].dealerHeading
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: _dealerDetails["default"].dealerName
    }, dealerName)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: _dealerDetails["default"].dealerAddress + " " + theme.smallType
    }, dealerAddress), departmentsCode && departmentsCode.map(function (departmentCode) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: departmentCode + "-deptCode",
        className: _dealerDetails["default"].departmentName + " " + theme.smallType
      }, departmentCode === 'sales' ? salesLabel : servicesLabel);
    })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerDetails["default"].dealerHoursTitle
    }, isMobile && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      clickEvent: this.toggleTimings,
      data: {
        label: 'Opening Hours',
        priority: 'lowIcon',
        icon: 'ChevronDown'
      },
      iconRight: true,
      theme: theme
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerDetails["default"].dealerHours
    }, isTimingsVisible && dealerDepartments && /*#__PURE__*/_react["default"].createElement(_dealerHours["default"], {
      dealerDepartments: dealerDepartments,
      saleOpeningHoursLabel: saleOpeningHoursLabel,
      serviceOpeningHoursLabel: serviceOpeningHoursLabel,
      theme: theme
    })))));
  };
  return DealerDetails;
}(_react["default"].Component);
exports["default"] = DealerDetails;